import React from "react";
import { Row, Col, Modal } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import DefaultProductImage from "../../../../assets/images/no-image.svg";
import data from "../../../../constants/retailPos.json";

const OfferSelectionModal = ({
  displayOfferProductSelectiton,
  setDisplayOfferProductSelection,
  offerProductsList,
  selectOfferProduct,
  setDefaultImage,
}) => {
  return (
    <Modal
      open={displayOfferProductSelectiton}
      footer={null}
      closable={true}
      styles={{ body: { padding: 0 } }}
      // width="30%"
      onCancel={() => {
        setDisplayOfferProductSelection(false);
        const productSearchInput = document.getElementById("sm-product-search");
        if (productSearchInput) {
          setTimeout(() => {
            productSearchInput.focus();
          }, 300);
        }
      }}
    >
      <Row style={data.posScreenStyles.offerSelectionModal.mainRow}>
        <Col span={24}>
          <p style={data.posScreenStyles.offerSelectionModal.title}>Select an Offer Product</p>
        </Col>
        {/* <Col span={12}>
          <p style={data.posScreenStyles.offerSelectionModal.closeIconP}>
            <CloseOutlined onClick={() => setDisplayOfferProductSelection(false)} style={data.posScreenStyles.offerSelectionModal.closeIcon} />
          </p>
        </Col> */}
      </Row>
      {/* {offerProductsList
        ? offerProductsList?.map((offerData, index) => (
            <Row key={`${offerData.name}-${index}`} style={data.posScreenStyles.offerSelectionModal.offerBtnsRow}>
              <Col span={24}>
                {console.debug(offerData,"offerData-----------")}
                <Button size="large" onClick={() => selectOfferProduct(offerData)} style={data.posScreenStyles.offerSelectionModal.offerBtn}>
                  {offerData.name}
                </Button>
              </Col>
            </Row>
          ))
        : ""} */}
      {offerProductsList?.length > 0 ? (
        <Scrollbars className="offerProductScroll1">
          {offerProductsList.map((obj, i) => (
            <Row
              gutter={[15, 11]}
              style={{
                width: "99%",
                backgroundColor: "#fff",
                marginTop: "1.5vh",
                height: "11vh",
                marginLeft: "-0.1vw",
                borderRadius: "10px",
              }}
            >
              <Col span={4}>
                <img
                  onError={setDefaultImage}
                  style={{
                    width: "100%",
                    height: "10vh",
                    objectFit: "contain",
                    borderRadius: "5px",
                    paddingTop: "1vh",
                    alignSelf: "center",
                  }}
                  src={obj.imageurl || DefaultProductImage}
                  alt=""
                />
              </Col>
              <Col span={16}>
                <label style={data.posScreenStyles.productsCard.cardDetails.productDescr} className="productName">
                  {obj["description"] || "description"}
                </label>
                <p style={data.posScreenStyles.productsCard.cardDetails.superMarketProd} className="productName">
                  {obj["name"]}
                </p>
              </Col>
              <Col
                span={4}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <span
                  onClick={() => {
                    selectOfferProduct(obj);
                  }}
                  style={{
                    fontSize: "1.5vh",
                    color: "#fff",
                    backgroundColor: "#2F3856",
                    padding: "1vh 2vw",
                    marginTop: "2%",
                    borderRadius: "3px",
                    cursor: "pointer",
                  }}
                >
                  ADD
                </span>
              </Col>
              <span tabIndex={0}></span>
            </Row>
          ))}
        </Scrollbars>
      ) : (
        ""
      )}
    </Modal>
  );
};

export default OfferSelectionModal;
